import React, { useState, useEffect } from "react";
import useMenusStore from "../../store/menusStore";
import MenuTabs from "../../components/admin/menus/tabs";
import useAdminAPI from "../../hooks/useAdminAPI";
import Categories from "../../components/admin/menus/categories";
import Items from "../../components/admin/menus/items";

const Menus = () => {
    const { activeMenu, setActiveMenu } = useMenusStore();
    const [modal, setModal] = useState({
        isVisible: false,
        onConfirm: null,
        message: "",
    });

    const { fetchMenus, fetchCategories, fetchItems } = useAdminAPI();

    useEffect(() => {
        fetchMenus();
        fetchCategories();
        fetchItems();
    }, []);

    const handleModalConfirm = () => {
        if (modal.onConfirm) modal.onConfirm();
        setModal({ isVisible: false, onConfirm: null, message: "" });
    };

    const handleModalCancel = () => {
        setModal({ isVisible: false, onConfirm: null, message: "" });
    };

    return (
        <div className="p-6 bg-gray-100 min-h-screen">
            <MenuTabs activeMenu={activeMenu} setActiveMenu={setActiveMenu} />

            <Categories />

            <Items />

            {modal.isVisible && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white p-6 rounded shadow-lg text-center">
                        <p className="mb-4">{modal.message}</p>
                        <div className="flex justify-center">
                            <button
                                onClick={handleModalConfirm}
                                className="bg-red-500 text-white px-4 py-2 rounded mr-2"
                            >
                                Confirm
                            </button>
                            <button
                                onClick={handleModalCancel}
                                className="bg-gray-300 px-4 py-2 rounded"
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Menus;
